import { render } from "./SceneObjListItemContent.vue?vue&type=template&id=48f11545&scoped=true"
import script from "./SceneObjListItemContent.vue?vue&type=script&lang=js"
export * from "./SceneObjListItemContent.vue?vue&type=script&lang=js"

import "./SceneObjListItemContent.vue?vue&type=style&index=0&id=48f11545&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f11545"]])

export default __exports__